// Centralized emote resolution. Converts keywords/aliases into either
// a sprite key (if preloaded) or a text emoji fallback.

export function resolveEmoteToken(input, textures) {
  const t = String(input || '').trim().toLowerCase();

  const spriteIfExists = (key, fallback) => {
    try {
      if (textures && typeof textures.exists === 'function' && textures.exists(key)) {
        return { kind: 'sprite', key };
      }
    } catch (_) {}
    return { kind: 'text', text: fallback };
  };

  // Common aliases
  switch (t) {
    case 'show':
    case 'highlight':
    case 'sparkles':
      return { kind: 'text', text: '✨' };
    case 'hi':
    case 'hello':
    case 'wave':
      return { kind: 'text', text: '👋' };
    case 'heal':
    case 'potion':
      return { kind: 'text', text: '🧪' };
    case 'coin':
    case '🪙':
      // Prefer coin sprite if available; fallback to emoji
      return spriteIfExists('spin-coin', '🪙');
    case 'attack':
    case 'fight':
      return { kind: 'text', text: '⚔️' };
    case 'run':
    case 'flee':
      return { kind: 'text', text: '💨' };
    case 'love':
    case 'heart':
      return { kind: 'text', text: '❤️' };
    case 'skull':
      return spriteIfExists('skullbones1', '💀');
    case 'blood':
      return spriteIfExists('blood1', '🩸');
    case 'red':
    case 'redsquare':
      return spriteIfExists('particle-red', '🔴');
    case 'white':
      return spriteIfExists('particle-white', '⚪');
    case 'yellow':
      return spriteIfExists('particle-yellow', '🟡');
    default:
      break;
  }

  // Explicit sprite:key syntax
  if (t.startsWith('sprite:')) {
    const key = t.slice('sprite:'.length);
    if (key) return spriteIfExists(key, '✨');
  }

  // Fallback: if input seems like an emoji, use it; else default sparkle
  if (input && /\p{Extended_Pictographic}/u.test(String(input))) {
    return { kind: 'text', text: String(input) };
  }
  return { kind: 'text', text: '✨' };
}


